import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import config from './config'
import * as serviceWorker from './serviceWorker';
import LogRocket from 'logrocket';

if (config.env !== 'local') {
  LogRocket.init('mznh9e/flatworld');
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
